import {FileFormatType} from '../constants';
import {FileFormatTypeLabel} from '../locales';

export const getFileFormatTypeLabel = (type: FileFormatType) =>
	FileFormatTypeLabel[type];

export default getFileFormatTypeLabel;
